<template>
  <div>
    <!-- filter section -->
    <b-card
      no-body
    >
      <b-card-body>
        <b-row class="justify-content-between">
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <h6>Menampilkan laporan bulanan</h6>
            <h4>
              {{
                selectedFilter.startMonth !== selectedFilter.endMonth
                  || selectedFilter.startYear !== selectedFilter.endYear
                  ? selectedFilter.startMonth : ''
              }}
              {{
                selectedFilter.startYear !== selectedFilter.endYear
                  ? selectedFilter.startYear : ''
              }}
              {{
                selectedFilter.startMonth !== selectedFilter.endMonth
                  || selectedFilter.startYear !== selectedFilter.endYear
                  ? '-' : ''
              }}
              {{ selectedFilter.endMonth }}
              {{ selectedFilter.endYear }}
            </h4>
          </b-col>
          <b-col
            cols="12"
            md="9"
            class="mb-md-0 mb-2"
          >
            <b-row>
              <b-col
                cols="12"
              >
                <FilterForm
                  :data="filter"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row
          v-if="!isPending && !reportMounthly.length"
          align-v="center"
          class="mt-3"
        >
          <b-col>
            <b-alert
              show
              variant="warning"
            >
              <div class="alert-body">
                <feather-icon
                  class="mr-25"
                  icon="AlertCircleIcon"
                />
                <span class="ml-25">Data tidak ditemukan</span>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- recapt section -->
    <div v-if="!isPending && reportMounthly.length">
      <b-row
        class="match-height"
      >
        <b-col
          xl="3"
          lg="4"
          md="12"
        >
          <OverviewCountTotalProducts :data="reportMounthly" />
        </b-col>
        <b-col
          xl="5"
          lg="8"
          md="12"
        >
          <OverviewSales :data="reportMounthly" />
        </b-col>
        <b-col
          xl="4"
          lg="12"
          md="12"
        >
          <OverviewPaymentTransaction
            :data="reportMounthly"
            :filter="filter"
          />
        </b-col>
      </b-row>

      <!-- chart section -->
      <b-row
        class="match-height"
      >
        <b-col
          xl="4"
          md="12"
        >
          <ChartSalesTotal
            :data="reportMounthly"
            :chart-option="chartOption"
            :label-yaxis="labelYaxisCurrentcy"
          />
        </b-col>
        <b-col
          xl="4"
          md="12"
        >
          <ChartCountTotalProducts
            :data="reportMounthly"
            :chart-option="chartOption"
            :label-yaxis="labelYaxisCount"
          />
        </b-col>
        <b-col
          xl="4"
          md="12"
        >
          <ChartAvgSalesTotal
            :data="reportMounthly"
            :chart-option="chartOption"
            :label-yaxis="labelYaxisCurrentcy"
          />
        </b-col>
      </b-row>
    </div>

    <!-- loading -->
    <b-row
      v-if="isPending"
      align-v="center"
    >
      <b-col
        xl="12"
        md="12"
        class="text-center"
      >
        <b-spinner
          variant="primary"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BRow, BCol, BCard,
  BCardBody, BAlert,
  BSpinner,
} from 'bootstrap-vue'
// import Chart from './Chart.vue'
import moment from 'moment'
import FilterForm from './FilterForm.vue'
import ChartCountTotalProducts from './ChartCountTotalProducts.vue'
import OverviewCountTotalProducts from './OverviewCountTotalProducts.vue'
import ChartSalesTotal from './ChartSalesTotal.vue'
import ChartAvgSalesTotal from './ChartAvgSalesTotal.vue'
import OverviewSales from './OverviewSales.vue'
import OverviewPaymentTransaction from './OverviewPaymentTransaction.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BAlert,
    BSpinner,

    // Chart,
    FilterForm,
    ChartCountTotalProducts,
    OverviewCountTotalProducts,
    ChartSalesTotal,
    ChartAvgSalesTotal,
    OverviewSales,
    OverviewPaymentTransaction,
  },
  data() {
    const now = new Date()
    return {
      isPending: false,
      filter: {
        startMonth: moment().subtract(3, 'months').month() + 1, // from 3 months ago
        endMonth: moment().subtract(1, 'months').month() + 1,
        startYear: moment().subtract(3, 'months').year(),
        endYear: moment().subtract(1, 'months').year(),
      },
      yearSelected: now.getFullYear(),
      chartOption: {
        chart: {
          toolbar: {
            show: false,
          },
          type: 'line',
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px',
          fontFamily: 'Montserrat',
        },
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
      },
      labelYaxisCurrentcy: {
        yaxis: {
          labels: {
            formatter(value) {
              function getMoneyLabel(val) {
                if (val >= 1000000000000) return ' T'
                if (val >= 1000000000) return ' M'
                if (val >= 1000000) return ' Jt'
                if (val >= 1000) return ' Rb'
                return ',-'
              }

              function getMoneyValue(val) {
                const valueAbs = Math.abs(val)
                if (valueAbs >= 1000000000000) return val / 1000000000000
                if (valueAbs >= 1000000000) return val / 1000000000
                if (valueAbs >= 1000000) return val / 1000000
                if (valueAbs >= 1000) return val / 1000
                return val
              }

              return `Rp ${getMoneyValue(value)}${getMoneyLabel(value)}`
            },
          },
        },
        tooltip: {
          shared: true,
          y: {
            formatter(value) {
              if (!value && value !== 0) {
                return null
              }

              return `Rp ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
            },
            title: {
              formatter: seriesName => seriesName,
            },
          },
        },
      },
      labelYaxisCount: {
        yaxis: {
          labels: {
            formatter(value) {
              function getCountLabel(val) {
                if (val >= 1000) return ' K'
                return ''
              }

              function getCountValue(val) {
                const valueAbs = Math.abs(val)
                if (valueAbs >= 1000) return val / 1000
                return val
              }

              return `${getCountValue(value)}${getCountLabel(value)}`
            },
          },
        },
        tooltip: {
          shared: true,
          y: {
            formatter(value) {
              if (!value && value !== 0) {
                return null
              }

              return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
            },
            title: {
              formatter: seriesName => seriesName,
            },
          },
        },
      },
    }
  },
  computed: {
    ...mapState('dashboard', ['reportMounthly', 'monthsOptions']),
    selectedFilter() {
      return {
        startMonth: this.monthsOptions.find(el => el.value === this.filter.startMonth).label,
        endMonth: this.monthsOptions.find(el => el.value === this.filter.endMonth).label,
        startYear: this.filter.startYear,
        endYear: this.filter.endYear,
      }
    },
  },
  watch: {
    filter: {
      async handler(val) {
        await this.loadData(val)
      },
      deep: true,
    },
  },
  async created() {
    await this.loadData(this.filter)
  },
  methods: {
    ...mapActions('dashboard', ['getReportMounthly']),
    async loadData(data) {
      this.isPending = true
      await this.getReportMounthly(data)
      this.isPending = false
    },
  },
}
</script>
